export default "__VITE_ASSET__Cz4YnQ3L__"